import React, { Fragment } from 'react'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

const authenticatedOptions = (
  <Fragment>
    <Nav.Link href="#change-password">Change Password</Nav.Link>
    <Nav.Link href="#sign-out">Sign Out</Nav.Link>
  </Fragment>
)

const unauthenticatedOptions = (
  <Fragment>
    <Nav.Link href="#sign-up">Sign Up</Nav.Link>
    <Nav.Link href="#sign-in">Sign In</Nav.Link>
  </Fragment>
)

const alwaysOptions = (
  <Fragment></Fragment>
)

const Header = ({ user }) => (
  <Navbar variant="dark" expand="md" collapseOnSelect>
    <Navbar.Brand href="#">Kino Chat</Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="ml-auto">
        { user && <span className="navbar-text mr-2">Welcome, {user.email}</span>}
        { alwaysOptions }
        { user ? authenticatedOptions : unauthenticatedOptions }
      </Nav>
    </Navbar.Collapse>
  </Navbar>
)

// links
// { user && (<Fragment>
//   <Nav className="m-auto"><Nav.Link href="#messages">Messages</Nav.Link></Nav>
//   <Nav className="m-auto"><Nav.Link href="#messages/new">Create</Nav.Link></Nav>
// </Fragment>)}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js